import * as ActionTypes from '../actions/index';
import _ from 'lodash';
import {NOT_FOUND_MESSAGE} from "../helpers/variables";
import moment from "moment";

const defaultState = {
	groups: [],
	solicitors: [],
	underwriters: [],
	workSources: [],
	selectedSolicitors: [{
		id: 0
	}],
	selectedUnderwriter: {
		id: 0,
		name: 'Please, select an underwriter.'
	},
	selectedWordingCategory: null,
	groupUnderwriters: [],
	selectedWorkSources: [
		{id: 0}
	],
	requiredWorkSource: false,
	attachXmlInEmails: false,
	checkedSolicitorsIds: [],
	checkedWorkSourcesIds: [],
	name: '',
	postGroupResponse: [],
	badResponse: '',
	patchCounter: 0,
	totalPatches: -1,
	successMsg: '',
	failedMsg: '',
	postingGroup: false,
	fetchingSolicitors: false,
	fetchingWorkSources: false,
	fetchingUnderwriters: false,
	badResponseMessage: '',
	receivedGroupId: '',
	fetchingSolicitorGroupById: false,
	deleteModal: false,
	solicitorFilter: '',
	selectedCaseTypes: [],
	checkedCaseTypesIds: [],
	selectedSubCaseTypes: [],
	checkedSubCaseTypesIds: [],
	shouldRenderGroupSelect: false,
	activePanel: 'general',
	advancedDisbursementsFormData: {
		shouldBeAbleToApply: false,
		selectedCaseTypes: [],
		checkedCaseTypesIds: [],
		selectedExpenseTypes: [],
		checkedExpenseTypesIds: [],
		checkedExpenseTypesPerCaseType: {}, // caseTypeId: {expenseTypeId: true/false}
		shouldProvideCaseUpdate: false,
		selectedSubCaseTypes: [],
		checkedSubCaseTypesIds: [],
		numberOfWeeks: '',
		adVerified: false,
		adWarningMessage: '',
		minDisbursementAmount: '',
		maxDisbursementAmount: '',
		maxAggregatedDisbursementAmount: '',
	},
	selectedToba: '',
	tobaFormModalOpen: false,
	tobaChanged: false,
	selectedTobaMsg: '',
	warnings: {},
	referToByCaseType: {}, // {...referToByCaseType, caseTypeId: {cmu: false, tuw: false, medical: false} }
	referToBySubCaseType: {}, // {...referToBySubCaseType, caseTypeId: {cmu: false, tuw: false, medical: false} },
	failedToFetchMessage: '',
	deleteSolicitorGroupFailMessage: '',
};

export default (state = defaultState, action) => {
	switch (action.type) {
		case ActionTypes.REMOVE_SOLICITOR_GROUP_UNDERWRITER:
			let groupUnderwriterAfterRemoval = state.groupUnderwriters
				.filter((item, key) => {
					return key !== action.payload.indexOfItemToRemove
				});

			groupUnderwriterAfterRemoval = groupUnderwriterAfterRemoval
				.map((item,key) => {
					if(key + 1 === groupUnderwriterAfterRemoval.length){
						return {
							...item,
							validTo: null,
							updateRelatedPolicies: action.payload.updateRelatedPolicies
						}

					}

					return item;
				});

			return {
				...state,
				groupUnderwriters: groupUnderwriterAfterRemoval,
			};
		case ActionTypes.ADD_SOLICITOR_GROUP_UNDERWRITER:
			const newSolGroupUnderwriters = [
				...state.groupUnderwriters
					.map((uw, indx) => {
						if((indx + 1 < state.groupUnderwriters.length)){
							return uw;
						}

						return {
							...uw,
							validTo: moment(action.payload.underwriter.validFrom, 'DD/MM/YYYY')
								.subtract(1, 'days')
								.toDate()
						}
					}),
				action.payload.underwriter
			]

			return {
				...state,
				groupUnderwriters: newSolGroupUnderwriters,
			};
		case ActionTypes.EDIT_SOLICITOR_GROUP_UNDERWRITER:
			let newUnderwriters = state.groupUnderwriters
				.filter(uw => {
					return moment(uw.validFrom).isBefore(moment(action.payload.underwriter.validFrom, 'DD/MM/YYYY'))
				})

			newUnderwriters= [
				...newUnderwriters
					.map((uw, indx) => {
						if((indx + 1 < newUnderwriters.length)){
							return uw;
						}

						return {
							...uw,
							validTo: moment(action.payload.underwriter.validFrom, 'DD/MM/YYYY')
								.subtract(1, 'days').toDate()
						}
					}),
				action.payload.underwriter,
			]

			return {
				...state,
				groupUnderwriters: newUnderwriters,
			}
		case ActionTypes.BAD_RESPONSE_DELETE_SOLICITOR_GROUP:
			let x = '';
			try {
				x = action.payload.response.body.message
			} catch (e) {
				x = 'Failed to delete solicitor group.'
			}
			return {
				...state,
				deleteSolicitorGroupFailMessage: x
			};
		case ActionTypes.CHANGE_REFER_TO_BY_CASE_TYPE:
			let def = {
				cmu: false,
				tuw: false,
				medical: false
			};
			return {
				...state,
				referToByCaseType: {
					...state.referToByCaseType,
					[action.payload.caseTypeId]: {
						...def,
						[action.payload.key]: action.payload.value
					}
				}
			};
		case ActionTypes.CHANGE_REFER_TO_BY_SUB_CASE_TYPE:
			let d = {
				cmu: false,
				tuw: false,
				medical: false
			};
			return {
				...state,
				referToBySubCaseType: {
					...state.referToBySubCaseType,
					[action.payload.subCaseTypeId]: {
						...d,
						[action.payload.key]: action.payload.value
					}
				}
			};
		case ActionTypes.CHANGE_SELECTED_TOBA:
			return {
				...state,
				selectedToba: action.payload,
				tobaChanged: true
			};
		case ActionTypes.RECEIVE_POST_NEW_TOBA_RESPONSE:
			return {
				...state,
				tobaFormModalOpen: false
			};
		case ActionTypes.CHANGE_AD_EXPENSE_TYPES:
			return {
				...state,
				advancedDisbursementsFormData: {
					...state.advancedDisbursementsFormData,
					checkedExpenseTypesPerCaseType: {
						...state.advancedDisbursementsFormData.checkedExpenseTypesPerCaseType,
						[action.payload.caseTypeId]: {
							...state.advancedDisbursementsFormData.checkedExpenseTypesPerCaseType[action.payload.caseTypeId],
							[action.payload.key]: action.payload.value
						}
					}
				}
			};
		case ActionTypes.CHANGE_ADVANCED_DISBURSEMENTS_FORM_DATA:
			return {
				...state,
				advancedDisbursementsFormData: {
					...state.advancedDisbursementsFormData,
					[action.payload.key]: action.payload.value
				}
			};
		case ActionTypes.RECEIVE_DELETE_SOLICITOR_GROUP:
			return {
				...state,
				deleteModal:false
			};
		case ActionTypes.REQUEST_GET_SPECIFIC_SOLICITOR_GROUP_EDIT:
			return {
				...state,
				fetchingSolicitorGroupById: true
			};
		case ActionTypes.RECEIVE_WORK_SOURCES_EDIT:
			return {
				...state,
				workSources: action.payload.worksources
			};
		case ActionTypes.RECEIVE_UNDERWRITERS_EDIT:
			return {
				...state,
				underwriters: action.payload.underwriters
			};
		case ActionTypes.RECEIVE_SOLICITOR_EDIT:
			return {
				...state,
				solicitors: action.payload.solicitors
			};
		case ActionTypes.RECEIVE_GET_SPECIFIC_SOLICITOR_GROUP:
			if(!action.payload) return {
				...defaultState,
				failedToFetchMessage: NOT_FOUND_MESSAGE
			};
			let underwriters = state.underwriters;
			let fetchedGroupedUW = action.payload.solicitorGroupUnderwriters.map(i => ({
				id: i.id,
				underwriterId: i.underwriterId,
				underwriterName: i.underwriterName,
				solicitorGroupId: i.solicitorGroupId,
				validFrom: i.validFrom,
				validTo: i.validTo,
			}));

			let workSources = state.workSources;
			let selectedWorksources = action.payload.workSources;
			let checkedWorkSourcesIds = action.payload.workSources.map(w => {return w.id});
			let selectedSolicitors = [];
			let checkedSolicitorsIds = [];
			for (let i = 0; i < action.payload.solicitors.length; i++) {
				checkedSolicitorsIds.push(action.payload.solicitors[i].lawsysFirmId);
				selectedSolicitors.push({
					id: action.payload.solicitors[i].lawsysFirmId,
					name: action.payload.solicitors[i].lawsysFirm,
				})
			}
			let caseTypes = action.payload.caseTypes;
			let selectedCaseTypes = [];
			let checkedCaseTypesIds = [];
			let selectedSubCaseTypes = [];
			let checkedSubCaseTypesIds = [];
			let referToByCaseTypeDto = {};
			let referToBySubCaseTypeDto = {};
			_.forEach(caseTypes, (caseType) => {
				selectedCaseTypes = [...selectedCaseTypes, caseType];
				checkedCaseTypesIds = [...checkedCaseTypesIds, caseType.id];
				selectedSubCaseTypes = [...selectedSubCaseTypes, ...caseType.subCaseTypes.map(item => {return item} )];
				checkedSubCaseTypesIds = [...checkedSubCaseTypesIds, ...caseType.subCaseTypes.map(item => {return item.id} )];
				referToByCaseTypeDto = {
					...referToByCaseTypeDto,
					[caseType.id]: {
						medical: caseType.medical,
						tuw: caseType.tuw,
						cmu: caseType.cmu,
					}
				};
				_.forEach(caseType.subCaseTypes, subCase => {
					referToBySubCaseTypeDto = {
						...referToBySubCaseTypeDto,
						[subCase.id]: {
							medical: subCase.medical,
							tuw: subCase.tuw,
							cmu: subCase.cmu,
						}
					};
				})
			});
			let advancedDisbursementsFormData = {
				shouldBeAbleToApply: action.payload.disbursementsAllowed?action.payload.disbursementsAllowed:false,
				shouldProvideCaseUpdate: action.payload.updateCaseBeforeDisbursements?action.payload.updateCaseBeforeDisbursements:false,
				numberOfWeeks: action.payload.maxWeeksSinceLastUpdateToAllowDisbursementsApplication?action.payload.maxWeeksSinceLastUpdateToAllowDisbursementsApplication:'',
				selectedCaseTypes: action.payload.disbursementsCaseTypeAndExpenseDtos.map(i => ({id: i.id, name: i.name})),
				checkedCaseTypesIds: action.payload.disbursementsCaseTypeAndExpenseDtos.map(i => i.id)
			};
			let adSubCaseTypes = [];
			let adSubCaseTypesIds = [];
			let checkedExpenseTypesPerCaseType;
			_.forEach(action.payload.disbursementsCaseTypeAndExpenseDtos, i => {
				let expenses = {};
				_.forEach(i.expenseTypeDtos, e => {
					expenses = {
						...expenses,
						[e.id]: true
					};
				});
				checkedExpenseTypesPerCaseType = {
					...checkedExpenseTypesPerCaseType,
					[i.id]: expenses
				};
				_.forEach(i.subCaseTypes, s => {
					adSubCaseTypes.push({
						id: s.id,
						name: s.name
					});
					adSubCaseTypesIds.push(s.id)
				})
			});
			advancedDisbursementsFormData.checkedExpenseTypesPerCaseType = checkedExpenseTypesPerCaseType;
			advancedDisbursementsFormData.selectedSubCaseTypes = adSubCaseTypes;
			advancedDisbursementsFormData.checkedSubCaseTypesIds = adSubCaseTypesIds;
			advancedDisbursementsFormData.minDisbursementAmount = action.payload.minDisbursementAmount?action.payload.minDisbursementAmount:'';
			advancedDisbursementsFormData.maxDisbursementAmount = action.payload.maxDisbursementAmount?action.payload.maxDisbursementAmount: '';
			advancedDisbursementsFormData.maxAggregatedDisbursementAmount = action.payload.maxAggregatedDisbursementAmount?action.payload.maxAggregatedDisbursementAmount: '';

			return {
				...state,
				name: action.payload.name,
				requiredWorkSource:  action.payload.requiredWorkSource,
				attachXmlInEmails:  action.payload.attachXmlInEmails,
				groupUnderwriters: fetchedGroupedUW,
				selectedWorkSources: selectedWorksources,
				checkedWorkSourcesIds: checkedWorkSourcesIds,
				selectedSolicitors: selectedSolicitors,
				checkedSolicitorsIds: checkedSolicitorsIds,
				receivedGroupId: action.payload.id,
				selectedWordingCategory: action.payload.wordingCategoryId,
				fetchingSolicitorGroupById: false,
				selectedCaseTypes: selectedCaseTypes,
				checkedCaseTypesIds: checkedCaseTypesIds,
				selectedSubCaseTypes: selectedSubCaseTypes,
				checkedSubCaseTypesIds: checkedSubCaseTypesIds,
				advancedDisbursementsFormData: {
					...defaultState.advancedDisbursementsFormData,
					...advancedDisbursementsFormData
				},
				referToByCaseType: referToByCaseTypeDto,
				referToBySubCaseType: referToBySubCaseTypeDto,
				selectedToba: action.payload.tobaDto?action.payload.tobaDto.id:''
			};
		case ActionTypes.RECEIVE_LAWSYS_FIRMS:
			return {
				...state,
				solicitors: action.payload,
				fetchingSolicitors: false
			};
		case ActionTypes.REQUEST_LAWSYS_FIRMS:
			return {
				...state,
				selectedSolicitors: [],
				checkedSolicitorsIds: [],
				postGroupResponse: [],
				fetchingSolicitors: true
			};
		case ActionTypes.RECEIVE_GET_UNDERWRITERS:
			return {
				...state,
				underwriters: action.payload,
				fetchingUnderwriters: false
			};
		case ActionTypes.REQUEST_GET_UNDERWRITERS:
			return {
				...state,
				selectedUnderwriter: {
					id: 0,
					name: 'Please, select an underwriter.'
				},
				postGroupResponse: [],
				fetchingUnderwriters: false
			};
		case ActionTypes.RECEIVE_GET_WORK_SOURCES:
			return {
				...state,
				workSources: action.payload,
				fetchingWorkSources: false
			};
		case ActionTypes.REQUEST_GET_WORK_SOURCES: {
			return {
				...state,
				selectedWorkSources: [],
				checkedWorkSourcesIds: [],
				postGroupResponse: [],
				fetchingWorkSources: true
			}
		}
		case ActionTypes.CHANGE_SOLICITOR_GROUP_FIELD:
			return {
				...state,
				[action.payload.key]: action.payload.value,
				successMsg: '',
				failedMsg: '',
				badResponseMessage: action.payload.key === 'badResponseMessage'? action.payload.value: '',
				deleteSolicitorGroupFailMessage: defaultState.deleteSolicitorGroupFailMessage
			};
		case ActionTypes.CHANGE_SOLICITOR_GROUP_LIST_SETTINGS:
			if (action.payload.key === 'openModal' && (action.payload.value === false))
				return {
					...state,
					selectedSolicitors: [],
					selectedUnderwriter: {
						id: 0,
						name: 'Please, select an underwriter.'
					},
					selectedWorkSources: [],
					checkedSolicitorsIds: [],
					checkedWorkSourcesIds: [],
					name: '',
					badResponse: '',
					solicitorFilter:'',
					selectedCaseTypes: [],
					checkedCaseTypesIds: [],
					selectedSubCaseTypes: [],
					checkedSubCaseTypesIds: [],
					advancedDisbursementsFormData: defaultState.advancedDisbursementsFormData
				};
			else return {
				...state
			};
		case ActionTypes.CHANGE_NEW_SOL_FORM_SETTINGS:
			if (action.payload.key === 'openModal' && (action.payload.value === false))
				return {
					...state,
					selectedSolicitors: [],
					selectedUnderwriter: {
						id: 0,
						name: 'Please, select an underwriter.'
					},
					selectedWorkSources: [],
					checkedSolicitorsIds: [],
					checkedWorkSourcesIds: [],
					name: '',
					badResponse: '',
					solicitorFilter:''
				};
			else return {
				...state
			};
		case ActionTypes.CHANGE_FIELD:
			if (action.payload.key === 'openModal' && (action.payload.value === false))
				return {
					...state,
					selectedSolicitors: [],
					selectedUnderwriter: {
						id: 0,
						name: 'Please, select an underwriter.'
					},
					selectedWorkSources: [],
					checkedSolicitorsIds: [],
					checkedWorkSourcesIds: [],
					name: '',
					badResponse: '',
					solicitorFilter:'',
					advancedDisbursementsFormData: defaultState.advancedDisbursementsFormData
				};
			else return {
				...state
			};
		case ActionTypes.LOGOUT:
			return {
				...defaultState
			};
		case ActionTypes.RECEIVE_POST_SOLICITOR_GROUP_RESPONSES:
			return {
				...state,
				postGroupResponse: action.payload,
				tobaChanged: false,
				warnings: defaultState.warnings
			};
		case ActionTypes.REQUEST_POST_SOLICITOR_GROUP:
			return {
				...state,
				postingGroup: true,
				patchCounter: 0,
				totalPatches: -1,
			};
		case ActionTypes.REQUEST_PATCH_SOLICITOR_GROUP:
			return {
				...state,
				postingGroup: true
			};
		case ActionTypes.REQUEST_PATCH_SELECTED_SOLICITOR_GROUP:
			return {
				...state,
				postingGroup: true,
				patchCounter: 0,
				totalPatches: -1
			};
		case ActionTypes.CREATED_SOLICITOR_GROUP_RESPONSE:
			return {
				...state,
				postGroupResponse: [],
				selectedSolicitors: [],
				selectedUnderwriter: {
					id: 0,
					name: 'Please, select an underwriter.'
				},
				groupUnderwriters: [],
				selectedWorkSources: [],
				checkedSolicitorsIds: [],
				checkedWorkSourcesIds: [],
				name: '',
				badResponse: [],
				patchCounter: 0,
				totalPatches: -1,
				successMsg: '',
				failedMsg: '',
				postingGroup: false,
				selectedCaseTypes: [],
				checkedCaseTypesIds: [],
				selectedSubCaseTypes: [],
				checkedSubCaseTypesIds: [],
				solicitorFilter:'',
				advancedDisbursementsFormData: defaultState.advancedDisbursementsFormData
			};
		case ActionTypes.BAD_REQUEST_POST_SOLICITOR_GROUP:
			if (action.payload === 'There is already a solicitor group with the specified name. Please provide another one.') {
				return {
					...state,
					badResponseMessage: action.payload,
					postingGroup: false
				};
			};
			try {
				return {
					...state,
					badResponse: JSON.parse(action.payload),
					postingGroup: false
				};
			}
			catch (e) {
				return {
					...state,
					badResponse: action.payload,
					postingGroup: false
				};
			}
		case ActionTypes.BAD_REQUEST_RECEIVE_PATCH_SELECTED_SOLICITOR_GROUP:
			if (action.payload === 'There is already a solicitor group with the specified name. Please provide another one.') {
				return {
					...state,
					badResponseMessage: action.payload,
					postingGroup: false
				};
			}
			let bResponse = state.badResponse;
			let bResponseMessage = state.badResponseMessage;
			try {
				bResponse = JSON.parse(action.payload);
			}
			catch (e) {
				bResponseMessage = action.payload;
			}
			return {
				...state,
				badResponse: bResponse,
				badResponseMessage: bResponseMessage,
				postingGroup: false
			};
		case ActionTypes.RECEIVE_SOLICITOR_GROUPS:
			return {
				...state,
				groups: action.payload.data
			};
		case ActionTypes.RECEIVE_PATCH_SOLICITOR_GROUP:
			return {
				...state,
				patchCounter: state.patchCounter + 1,
				tobaChanged: defaultState.tobaChanged,
			};
		case ActionTypes.FAILED_TO_PATCH_SOLICITOR_GROUP:
			return {
				...state,
				postingGroup:false,
				failedMsg: 'Failed to make changes. Please try again later.',
				badResponse: [],
				patchCounter: 0,
				totalPatches: -1
			};
		case ActionTypes.RECEIVE_PATCH_SELECTED_SOLICITOR_GROUP:
			return {
				...state,
				successMsg: 'Solicitor group updated successfully.',
				postingGroup:false,
				badResponse: [],
				patchCounter: 0,
				totalPatches: -1,
				advancedDisbursementsFormData: {
					...state.advancedDisbursementsFormData,
					adVerified: false,
					adWarningMessage: ''
				},
				warning: defaultState.warnings
			};
		case '@@router/LOCATION_CHANGE':
			return {
				...defaultState,
				groups: state.groups,
				solicitors: state.solicitors,
				underwriters: state.underwriters,
				workSources: state.workSources,
				warning: defaultState.warnings
			};
		default:
			return state
	}
}
